<template>
  <div>
    <v-container fluid>

      <div class="main">

        <v-row v-if="isLoading">
          <v-col v-for="item in 4" :key="item" cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text>
                <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <div v-else>

          <v-row>

            <v-col cols="12" lg="3">
              <v-card class="rounded-lg shadow">
                <v-card-text class="py-5">
                  <v-row align="center" justify="center">
                    <v-col cols="3">
                      <v-avatar color="primary" size="45">
                        <v-icon color="white">mdi-calendar-today</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="9">
                      <div class="font-weight-black text-h6 pb-1 text-grey-darken-3">
                        {{ statistics.today }}
                      </div>
                      Aujourd’hui
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" lg="3">
              <v-card class="rounded-lg shadow">
                <v-card-text class="py-5">
                  <v-row align="center" justify="center">
                    <v-col cols="3">
                      <v-avatar color="info" size="45">
                        <v-icon color="white">mdi-calendar-week</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="9">
                      <div class="font-weight-black text-h6 pb-1 text-grey-darken-3">
                        {{ statistics.this_week }}
                      </div>
                      Cette semaine
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" lg="3">
              <v-card class="rounded-lg shadow">
                <v-card-text class="py-5">
                  <v-row align="center" justify="center">
                    <v-col cols="3">
                      <v-avatar color="warning" size="45">
                        <v-icon color="white">mdi-calendar-month</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="9">
                      <div class="font-weight-black text-h6 pb-1 text-grey-darken-3">
                        {{ statistics.this_month }}
                      </div>
                      Ce mois
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" lg="3">
              <v-card class="rounded-lg shadow">
                <v-card-text class="py-5">
                  <v-row align="center" justify="center">
                    <v-col cols="3">
                      <v-avatar color="success" size="45">
                        <v-icon color="white">mdi-counter</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="9">
                      <div class="font-weight-black text-h6 pb-1 text-grey-darken-3">
                        {{ statistics.all }}
                      </div>
                      Total
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

          </v-row>

        </div>

        <v-card class="rounded-lg shadow mt-3">

          <v-overlay :value="overlay"
                     absolute
                     color="white"
                     opacity="0.5">
            <v-progress-circular
                color="primary"
                indeterminate
                size="50"
            ></v-progress-circular>
          </v-overlay>

          <v-card-title>
            <div>
              <v-text-field
                  v-model="keyword"
                  @click:clear="[keyword = null,getUsages()]"
                  @keydown.enter="getUsages"
                  append-icon="mdi-magnify"
                  clearable
                  dense
                  filled
                  hide-details
                  placeholder="Recherche..."
                  rounded
                  single-line
              ></v-text-field>
            </div>

            <v-spacer/>

            <v-btn color="grey"
                   text
                   @click="$refs.filterDialog.open()">
              <v-icon left>mdi-filter-outline</v-icon>
              Filtre
            </v-btn>

            <v-btn color="grey"
                   text
                   @click="handleFilter">
              <v-icon left>mdi-refresh</v-icon>
              Mettre à jour
            </v-btn>

          </v-card-title>

          <v-divider/>

          <v-card-text v-if="isLoading" class="pa-0">
            <v-skeleton-loader type="table"/>
          </v-card-text>

          <div v-else>

            <v-card-text class="pa-0">

              <v-simple-table v-if=" usages.length">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>Campagne</th>
                    <th>Code</th>
                    <th>Utilisateur</th>
                    <th>Cadeau digital</th>
                    <th>Tracer <br> dans l’historique</th>
                    <th>POS</th>
                    <th>Platform</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,i) in  usages" :key="i">

                    <td class="text-no-wrap font-weight-medium">
                      {{ item.boosting_method?.name }}
                    </td>

                    <td class="text-no-wrap gifty--text font-weight-medium">
                      #{{ item.boosting_code?.code }}
                    </td>

                    <td>
                      <Avatar v-if="item.account && item.account"
                              :user="item.account"
                              :byAccount="true"/>
                      <span v-else>-</span>
                    </td>

                    <td class="text-no-wrap">
                      {{ item.boosting_physical_gift?.name ?? "-" }}
                    </td>

                    <td>
                      <v-switch v-model="item.track_in_history"
                                v-if="item.boosting_physical_gift_id"
                                class="pa-0 ma-0"
                                color="success"
                                hide-details
                                readonly
                                @click="changeStatus(item.id)"></v-switch>

                    </td>

                    <td class="text-no-wrap">
                      <Avatar v-if="item.salepoint_account && item.salepoint_account"
                              :user="item.salepoint_account"
                              :byAccount="true"/>
                      <span v-else>-</span>
                    </td>

                    <td>
                      <v-chip color="info" small>
                        <v-icon left small> {{
                            item.platform_used === 'web' ? 'mdi-desktop-mac' : 'mdi-cellphone'
                          }}
                        </v-icon>
                        {{ item.platform_used }}
                      </v-chip>
                    </td>

                    <td class="text-no-wrap">
                      {{ dateFormat(item.used_at) }}
                    </td>

                    <td>
                      <div class="d-flex">
                        <v-btn color="gifty" icon>
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                      </div>
                    </td>

                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div v-else>
                <NoResults @reload="getUsages"/>
              </div>

            </v-card-text>

            <v-divider/>

            <v-card-actions>

              <div :style="{width : '120px'}">
                <v-select v-model="perPage"
                          :items="[10,20,30,50,100]"
                          dense
                          hide-details
                          label="Ligne par page"
                          outlined
                ></v-select>
              </div>

              <v-spacer/>


              <v-pagination v-model="pagination.current"
                            :length="pagination.total"
                            circle
                            total-visible="7"
                            @input="getUsages"></v-pagination>

            </v-card-actions>

          </div>

        </v-card>

      </div>


      <FilterDialog ref="filterDialog" @filter="handleFilter"/>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults.vue";
import FilterDialog from "./components/FilterDialog.vue";
import moment from "moment";
import Avatar from "@/components/Avatar";

export default {
  components: {
    Avatar,
    FilterDialog,
    NoResults,
  },
  data() {
    return {
      id: null,
      isLoading: false,
      overlay: false,

      keyword: null,
      track_in_history: null,
      dates: [],

      usages: [],
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
      statistics: {},

    };
  },
  methods: {
    showAccount(account_id) {
      let route = this.$router.resolve({path: "/users/" + account_id})
      window.open(route.href, "_blank")
    },
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },
    getUsages() {
      this.isLoading = true
      HTTP.get('/v1/boosting-methods/usages?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword,
          dates: this.dates,
          track_in_history: this.track_in_history,
        }
      }).then(res => {
        this.isLoading = false
        this.pagination.current = res.data.data.data.current_page;
        this.pagination.total = res.data.data.data.last_page;
        this.usages = res.data.data.data.data
        this.statistics = res.data.data.statistics


      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    handleFilter(e) {
      this.dates = e.dates
      this.track_in_history = e.track_in_history
      this.getUsages()
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/boosting-methods/usages/" + id + "/change-visibility").then(() => {
        this.overlay = false;
        let index = this.usages.findIndex(el => el.id === id)
        this.usages[index].track_in_history = !this.usages[index].track_in_history
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
  },
  created() {
    this.getUsages()

  },
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getUsages()
    }
  },
};
</script>

<style scoped>
</style>
